import { HttpClient } from '@angular/common/http';
import { inject } from '@angular/core';
import { CanActivateChildFn, CanActivateFn, Router } from '@angular/router';
import { BACKEND_URLS } from 'app/app.config';
import { UserService } from 'app/core/user/user.service';
import { catchError, of, shareReplay, switchMap } from 'rxjs';
import { AuthUtils } from 'app/core/auth/auth.utils';
import { AuthService } from 'app/core/auth/rapallo/auth.service';


export const AuthGuard: CanActivateFn | CanActivateChildFn = (route, state) =>
{
    const router: Router = inject(Router);
    const authService = inject(AuthService);
    const _httpClient = inject(HttpClient);
    const _userService = inject(UserService);
    const backendUrls = inject(BACKEND_URLS);

    if (!AuthUtils.isTokenExpired(authService.accessToken)){

        //console.log("TOKEN SEMPRE VALIDO")
    }


    if (authService.authenticated){

        return of(true)
    }

    return _httpClient
    .post(`${backendUrls.backendApiUrl}/login/new_access_token`, {})
    .pipe(
        shareReplay(1),
        switchMap((response: any) => {

            if (!response.data){

                // Redirect to the sign-in page with a redirectUrl param
                const redirectURL = state.url === '/sign-out' ? '' : `redirectURL=${state.url}`;
                const urlTree = router.parseUrl(`sign-in?${redirectURL}`);

                return of(urlTree);

            }

            if (response.data.access_token) {

                sessionStorage.setItem('__iol', response.data.access_token);

                _userService.user = response.data.user;
                // Set the authenticated flag to true
                authService.authenticated = true;

                // if(!response.data.user.is_superuser)
                // {
                //     window.location.href = "https://www.comune.rapallo.ge.it/"

                // }
                return of(true)

            }

        }),
        catchError((err) => {

            console.log(err)

            const message = 'Accesso al portale plone fallito';

            console.log("XXXXXXXXXXXXXXXXXXXXXXXXX")

            // window.location.href = "https://www.comune.rapallo.ge.it/"


                // Redirect to the sign-in page with a redirectUrl param
                const redirectURL = state.url === '/sign-out' ? '' : `redirectURL=${state.url}`;
                const urlTree = router.parseUrl(`sign-in?${redirectURL}`);

                return of(urlTree);
        }),

    )


};
